import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contactwala',
  templateUrl: './contactwala.component.html',
  styleUrls: ['./contactwala.component.css']
})
export class ContactwalaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
